import React from 'react';

const DoneIcon: React.FC = () => (
    <svg className="icon-done" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <circle cx="12" cy="12" r="12" fill="#D4E2FC" />
    <path d="M8 12.0002L10.8571 14.8574L16.5714 9.14307" stroke="#276EF1" strokeWidth={"2"}
        strokeLinecap={"round"} strokeLinejoin={"round"} />
    </svg>
);

export default DoneIcon;
